import { ColDef } from 'ag-grid-community';
import { CustomCellRendererProps } from 'ag-grid-react';
import { SymbolSyncPlanApiModel } from '../../../../types/models/sync/symbol-sync-plan.model';
import { SyncPlan } from './SyncPlan';
import { SymbolViewer } from '../Symbols/SymbolViewer';

type Props = { plan: SymbolSyncPlanApiModel; onPlanChanged?: (newPlan: SymbolSyncPlanApiModel) => void };

const rowHeight = 200;

export const SymbolSyncPlan = ({ plan, onPlanChanged }: Props) => {
  const columns: ColDef<
    | SymbolSyncPlanApiModel['create'][number]
    | SymbolSyncPlanApiModel['update'][number]
    | SymbolSyncPlanApiModel['delete'][number]
  >[] = [
    { field: 'name', filter: true, cellStyle: { fontSize: '1.5rem', lineHeight: `${rowHeight}px` } },
    {
      headerName: 'Thumbnail',
      cellRenderer: ({ data }: CustomCellRendererProps<SymbolSyncPlanApiModel['create'][number]>) => (
        <SymbolViewer width={rowHeight} height={rowHeight} coordinates={data?.coordinates ?? []} showPaddedViewbox />
      ),
    },
    {
      headerName: 'Old Thumbnail',
      cellRenderer: ({ data }: CustomCellRendererProps<SymbolSyncPlanApiModel['update'][number]>) =>
        data?.oldCoordinates ? (
          <SymbolViewer width={rowHeight} height={rowHeight} coordinates={data?.oldCoordinates} showPaddedViewbox />
        ) : null,
    },
    {
      field: 'library.name',
      headerName: 'Library',
      filter: true,
      filterParams: { filterOptions: ['contains'], maxNumConditions: 1 },
      cellStyle: { fontSize: '1.5rem', lineHeight: `${rowHeight}px` },
    },
  ];

  return <SyncPlan plan={plan} columns={columns} onPlanChanged={onPlanChanged} gridProps={{ rowHeight }} />;
};
